import React from 'react';
import './sectionHeading.css';

const SectionHeading = ({ label, title, description, align = 'left', variant }) => (
  <div className={`kw__section-heading kw__section-heading--${align}${variant ? ` kw__section-heading--${variant}` : ''}`}>
    {label && <p className="kw__section-heading_label">{label}</p>}
    {title && <h2 className="kw__section-heading_title">{title}</h2>}
    {description && <p className="kw__section-heading_description">{description}</p>}
  </div>
);

export default SectionHeading;
